import { NotificationInstance } from 'antd/es/notification/interface';

let notificationApi: NotificationInstance | null = null;

/**
 * Notification instance'ı kaydeder.
 * Örn: setNotificationApi(notification);
 */
export const setNotificationApi = (api: NotificationInstance) => {
  notificationApi = api;
};

/**
 * Notification gösterir (HTML destekli).
 * @param type - 'success' | 'error' | 'info' | 'warning'
 * @param message - Başlık
 * @param description - İçerik (HTML destekli)
 */
export const showNotification = (
  type: 'success' | 'error' | 'info' | 'warning',
  message: string,
  description: string
) => {
  if (notificationApi) {
    notificationApi.open({
      type,
      message,
      description: <div dangerouslySetInnerHTML={{ __html: description }} />,
      placement: 'topRight',
      showProgress: true,
      pauseOnHover: true,
    });
  } else {
    console.warn('notificationApi is not initialized. Please call setNotificationApi() inside a React component.');
  }
};